// import clone from 'clone'
// import { initialState } from '../index'
import { ACCOUNTS_INIT_LOADING, ACCOUNTS_INIT_SUCCESS, ACCOUNTS_INIT_FAIL, ACCOUNTS_DETAILS_INIT, GLTRAN_DETAIL, ACCOUNTS_LOAD_DATA, CHG_ACCT_MCH_UUID,
  CHG_ACCT_MCH_BASE, CHG_ACCT_MCH_SEL, CHG_ACCT_MCH_FILE, CHG_ACCT_MCH_RECKEY, CHG_ACCT_MCH_CANCEL, CHG_ACCT_MCH_ISUPLD
} from '@/store/types'

export const init = {
  [ACCOUNTS_INIT_LOADING](state) {
    state.init = 0
    state.initErr = []
    state.menu = {}
  },
  [ACCOUNTS_INIT_SUCCESS](state, data) {
    state.init = 1
    state.initErr = []
    state.menu = data.menu
  },
  [ACCOUNTS_INIT_FAIL](state, error) {
    state.init = 2
    state.initErr = error
    state.menu = {}
  },
  [ACCOUNTS_DETAILS_INIT](state, data) {
    state.init = 3
    state.initErr = []
    state.accountData = data
  },
  [GLTRAN_DETAIL](state, data) {
    state.glDetail.journal = data.journal
    state.glDetail.itemNo = data.itemNo
    state.glDetail.glAcctNo = data.glAcctNo
    state.glDetail.createdBy = data.createdBy
    state.glDetail.modifiedBy = data.modifiedBy
  },
  [ACCOUNTS_LOAD_DATA] (state, data) {
    state.acctMaster.branch = data.branch
    state.acctMaster.acctNo = data.acctNo
    state.acctMaster.tranType = data.type
    state.acctMaster.docNo = data.docNo
    state.acctMaster.fund = data.fund
    state.acctMaster.suffix = data.suffix
    state.acctMaster.rbcTran = data.rbcTran
    state.acctMaster.netAmount = data.netAmount
    state.acctMaster.osBalance = data.osBalance
    state.acctMaster.transfer = data.transfer
    state.acctMaster.actionName = data.actionName
    state.acctMaster.postNow = data.postNow
    state.acctMaster.createdProgId = data.createdProgId
  },
  [CHG_ACCT_MCH_UUID] (state, data) {
    state.acctMchObj.UUID = data
  },
  [CHG_ACCT_MCH_BASE] (state, data) {
    state.acctMchObj.baseFromMatch = data
  },
  [CHG_ACCT_MCH_SEL] (state, data) {
    state.acctMchObj.selectFromMatch = data
  },
  [CHG_ACCT_MCH_FILE] (state, data) {
    state.acctMchObj.matchFileName = data
  },
  [CHG_ACCT_MCH_RECKEY] (state, data) {
    state.acctMchObj.baseRecKey = data
  },
  [CHG_ACCT_MCH_CANCEL] (state, data) {
    state.acctMchObj.isCancel = data
  },
  [CHG_ACCT_MCH_ISUPLD] (state, data) {
    state.acctMchObj.isUpload = data
  }
}
